import { Card, CardContent } from '@/components/ui/card';
import { Heart, Skull } from 'lucide-react';

export const BirthSurvivalStats = ({ birthStats }) => {
  if (birthStats.totalAgneaux <= 0) return null;

  const barColor = birthStats.tauxSurvie >= 80 ? 'bg-slate-600' : 
                   birthStats.tauxSurvie >= 50 ? 'bg-amber-500' : 'bg-red-500';
  const rateColor = birthStats.tauxSurvie >= 80 ? 'text-slate-700 dark:text-slate-300' : 
                    birthStats.tauxSurvie >= 50 ? 'text-amber-600' : 'text-red-600';

  return (
    <Card className="border-0 shadow-md">
      <CardContent className="pt-6">
        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
          <div className="flex items-center gap-3">
            <div className="p-3 bg-slate-100 dark:bg-slate-800 rounded-full">
              <Heart className="w-6 h-6 text-slate-700 dark:text-slate-300" />
            </div>
            <div>
              <h3 className="font-semibold text-gray-900 dark:text-white">Taux de survie des agneaux</h3>
              <p className="text-sm text-gray-500 dark:text-gray-400">Basé sur {birthStats.totalAgneaux} agneau(x) né(s)</p>
            </div>
          </div>
          
          <div className="grid grid-cols-3 gap-6">
            <div className="text-center">
              <div className="flex items-center justify-center gap-2">
                <Heart className="w-5 h-5 text-slate-600 dark:text-slate-400" />
                <span className="text-2xl font-bold text-slate-700 dark:text-slate-300">{birthStats.agneauxVivants}</span>
              </div>
              <p className="text-xs text-gray-500 mt-1">Vivants</p>
            </div>
            <div className="text-center">
              <div className="flex items-center justify-center gap-2">
                <Skull className="w-5 h-5 text-red-500" />
                <span className="text-2xl font-bold text-red-600">{birthStats.agneauxMorts}</span>
              </div>
              <p className="text-xs text-gray-500 mt-1">Morts</p>
            </div>
            <div className="text-center">
              <div className={`text-2xl font-bold ${rateColor}`}>{birthStats.tauxSurvie}%</div>
              <p className="text-xs text-gray-500 mt-1">Taux survie</p>
            </div>
          </div>
          
          <div className="w-full md:w-48">
            <div className="h-3 bg-gray-200 rounded-full overflow-hidden">
              <div className={`h-full transition-all ${barColor}`} style={{ width: `${birthStats.tauxSurvie}%` }} />
            </div>
            <div className="flex justify-between text-xs text-gray-400 mt-1">
              <span>0%</span>
              <span>100%</span>
            </div>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};
